import { PDFAssociateDetailsProps } from '../../../utils/models';
import { concatClassNames } from '../../../utils/utilities';

import Conditional from '../../common/conditional';
import classNames from './pdf.module.scss';

const PDFAssociateDetails = (props: PDFAssociateDetailsProps): JSX.Element => {
	return (
		<table className={concatClassNames([classNames['pdf-table']])}>
			<thead>
				<tr>
					<th></th>
					<th>INSPECTED BY</th>
					<th>REVIEWED BY</th>
					<th>APPROVED BY</th>
				</tr>
			</thead>
			<tbody>
				<tr>
					<td className={classNames['title-grid']}>Name:</td>
					<td>{props.inspectorName}</td>
					<td>{props.reviewerName}</td>
					<td>{props.approverName}</td>
				</tr>
				<tr>
					<td className={classNames['title-grid']}>Position:</td>
					<td rowSpan={2}>{props.inspectorRole}</td>
					<td>{props.reviewerRole}</td>
					<td>{props.approverRole}</td>
				</tr>
				<tr>
					<td className={classNames['title-grid']}>Signature:</td>
					<td>
						<Conditional isVisible={!!props.reviewerSignature}>
							<img
								src={props.reviewerSignature}
								alt={`Signed By ${props.reviewerName}`}
								className={classNames['title-grid-signature']}
							/>
						</Conditional>
					</td>
					<td>
						<Conditional isVisible={!!props.approverSignature}>
							<img
								src={props.approverSignature}
								alt={`Signed By ${props.approverName}`}
								className={classNames['title-grid-signature']}
							/>
						</Conditional>
					</td>
				</tr>
				<tr>
					<td className={classNames['title-grid']}>Date:</td>
					<td>{props.inspectionDate}</td>
					<td>{props.reviewDate}</td>
					<td>{props.approvalDate}</td>
				</tr>
			</tbody>
		</table>
	);
};

export default PDFAssociateDetails;
